export const PredefinedForms = {
  MEDICATION: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  NUTRITION_AND_DAILY_ASSESSMENT_FORM: 'b2c3d4e5-f6g7-8901-bcde-f23456789012',
  SLEEP: 'e5f6g7h8-i9j0-1234-efgh-567890123456',
} as const

export const PREDEFINED_FORM_IDS: string[] = Object.values(PredefinedForms)
